import { SOGetPerson } from '../person/so-get-person';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPostAssignedProject {

  constructor(
    public name: string,
    public person: SOGetPerson,
    public project: SOGetProject,
    public organization: SOGetOrganization,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostAssignedProject(
      'name' in params ? params.name : null,
      'person' in params ? params.person : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
